import { render, staticRenderFns } from "./NewLoginEmail.vue?vue&type=template&id=57dae61a"
import script from "./NewLoginEmail.vue?vue&type=script&lang=js"
export * from "./NewLoginEmail.vue?vue&type=script&lang=js"
import style0 from "./NewLoginEmail.vue?vue&type=style&index=0&id=57dae61a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports